import { formatNumberISFloat } from '../Utils'

export const TranslatedTextHtml = {
	is: {
		calculator: {
			ltvTooltip({
				maxLtv,
				baseLtv,
				surchargePerPoint,
			}: {
				maxLtv: number
				baseLtv: number
				surchargePerPoint: number
			}): string {
				return (
					`Lánsupphæð að hámarki ${maxLtv}% af markaðsvirði húsnæðis en hagstæðustu kjörin eru á lánum allt að ` +
					`${baseLtv}% af markaðsvirði. Vaxtaálag hækkar um ${formatNumberISFloat(surchargePerPoint * 100)}% ` +
					`fyrir hvert prósentustig umfram ${baseLtv}%`
				)
			},
		},
	},
}
